<ng-container>
    <div class="table-list" *ngIf="loaded; else loading">
        <div class="table-list__container" [ngClass]="{'table-list__container--photo': photos.length}">
            <ng-container *ngIf="correspondences && correspondences.length">
                <div class="table-list__item table-list__header">Datum</div>
                <div class="table-list__item table-list__header">Onderwerp</div>
                <div class="table-list__item table-list__header">Van</div>
                <div class="table-list__item table-list__header">Aan</div>
                <div class="table-list__item table-list__header">Bijlage</div>
            </ng-container>
            <ng-container *ngIf="photos && photos.length">
                <div class="table-list__item table-list__header">Datum</div>
                <div class="table-list__item table-list__header">Afzender</div>
                <div class="table-list__item table-list__header">Onderwerp</div>
                <div class="table-list__item table-list__header">&nbsp;</div>
            </ng-container>
        </div>

        <ng-content></ng-content>

        <div class="table-list__empty"
             *ngIf="(correspondences && correspondences.length < 1) || (photos && photos.length < 1 && !correspondences)">
            <p>De map is leeg, omdat deze informatie voor uw claim niet nodig is.</p>
        </div>
    </div>
</ng-container>

<ng-template #loading>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line skeleton-loader__line--half no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
    <div class="skeleton-loader__line skeleton-loader__line--half no-float"></div>
    <div class="skeleton-loader__line no-float"></div>
</ng-template>
<ins-swipe-animation
    *ngIf="loaded && (isScreenMedium$ | async)"
    class="table-list__swipe-animation">
</ins-swipe-animation>
